import React from "react";
import CustomCard from "./CustomCard";
import CardHeader from "./CardHeader";
import { CardContent, Collapse } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledCardContent = styled(CardContent)(({ theme }) => ({
  backgroundColor: "#fbfbfd",
}));

const Card = ({
  cardTitle,
  collapsible,
  children,
  icon,
  headerColor,
  color = "#fbfbfd", // Default color
  disableExpand,
  colorCode,
  onExpandChange,
  isTitleJsx,
  disabled,
  expanded = false, // ✅ Move default prop here
}) => {

  const [_expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!_expanded);
    if (onExpandChange) {
      onExpandChange(!_expanded);
    }
  };

  return (
    <CustomCard disabled={disabled}>
      <CardHeader
        isTitleJsx={isTitleJsx}
        colorCode={colorCode}
        cardTitle={cardTitle}
        handleExpandClick={
          disableExpand
            ? () => {
                //do nothing
              }
            : handleExpandClick
        }
        expanded={_expanded}
        collapsible={collapsible}
        icon={icon}
        headerColor={headerColor}
        fontColor="black"
      ></CardHeader>
      {collapsible ? (
        <Collapse
          sx={{ background: "#fbfbfd" }}
          in={_expanded}
          timeout={400}
          // unmountOnExit
        >
<StyledCardContent>{children}</StyledCardContent>
        </Collapse>
      ) : (
        <CardContent style={{ background: "#fbfbfd" }} >
          {children}
        </CardContent>
      )}
    </CustomCard>
  );
};

Card.CardHeader = CardHeader;

export default Card;
